import React, { memo } from "react";
import { useFeedbackDialog } from "./index.hooks";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Grid,
  Icon,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";
import { AppButton } from "../AppButton";
import { Replay } from "@mui/icons-material";
import SuccessIcon from "assets/success_Icon.svg";
import FailIcon from "assets/fail_icon.svg";
import { ReactComponent as rightArrow } from "assets/right-arrow.svg";

type FeedbackDialogProps = {};

export const FeedbackDialog = memo(({}: FeedbackDialogProps) => {
  const {
    isDialogOpen,
    isWin,
    chosenLevel,
    isMobile,
    feedbackColor,
    dialogActionsDirection,
    onDiscoverMoreButtonClicked,
  } = useFeedbackDialog();
  const failSubtitle = "Il tempo per risolvere il puzzle si è esaurito.";

  if (!chosenLevel) {
    return null;
  }

  return (
    <Dialog open={isDialogOpen} maxWidth={isMobile ? "xl" : "lg"}>
      <Box>
        <DialogTitle>
          <Stack
            direction="column"
            alignItems="center"
            justifyContent="space-evenly"
            textAlign="center"
          >
            <Icon
              sx={{
                textAlign: "center",
                width: "fit-content",
                height: "fit-content",
              }}
            >
              <Box
                component="img"
                src={isWin ? SuccessIcon : FailIcon}
                alt="Project Puzzle"
                sx={{ height: 90, width: "auto" }}
              />
              <Typography
                color={feedbackColor}
                textTransform="none"
                fontSize="38px"
                fontWeight="bolder"
                lineHeight={1}
                // sx={{ mt: 1 }}
              >
                {isWin ? "Complimenti!" : "Game over!"}
              </Typography>
              <Box sx={{ mt: 1, lineHeight: 1 }}>
                <Typography
                  display="inline"
                  color={feedbackColor}
                  textTransform="none"
                  fontSize="21px"
                  fontWeight="bolder"
                >
                  {isWin
                    ? chosenLevel.successDialogContent.subtitle
                    : failSubtitle}
                </Typography>
              </Box>
            </Icon>
          </Stack>
        </DialogTitle>
        <DialogContentText
          textAlign={isMobile ? "left" : "center"}
          justifyContent="center"
          alignItems="center"
        >
          <Box
            sx={{
              "& *": {
                textTransform: "none!important",
                fontSize: {
                  xs: "16px!important",
                  sm: "20px!important",
                  lg: "25px!important",
                  xl: "30px!important",
                },
                lineHeight: {
                  xs: "24px!important",
                  sm: "28px!important",
                  lg: "34px!important",
                  xl: "42px!important",
                },
              },
            }}
          >
            {isWin ? (
              chosenLevel.successDialogContent.contents.map((content) => (
                <Typography
                  display="inline"
                  sx={{
                    lineHeight: { xs: "16px", sm: "23px", lg: "30px" },
                    maxWidth: "84%",
                    fontWeight: content.isBold ? "bold" : "normal",
                  }}
                >
                  {content.text}
                </Typography>
              ))
            ) : (
              <>
                <Typography display="inline" fontWeight="bold">
                  Che ne dici: vuoi giocare nuovamente{" "}
                </Typography>
                <Typography display="inline">
                  e sfruttare l'esperienza che hai accumulato{" "}
                </Typography>
                <Typography display="inline" fontWeight="bold">
                  oppure andare direttamente alla soluzione del puzzle?
                </Typography>
              </>
            )}
          </Box>
        </DialogContentText>
      </Box>
      <DialogActions sx={{ mt: 2 }}>
        <Grid
          container
          alignItems="center"
          textAlign="center"
          direction={dialogActionsDirection}
        >
          <Grid item sm={6} xs={12}>
            <AppButton
              onClick={onDiscoverMoreButtonClicked}
              size={isMobile ? "medium" : "large"}
              variant={isMobile ? (isWin ? "outlined" : "text") : "outlined"}
              endIcon={
                <SvgIcon
                  component={rightArrow}
                  sx={{ mr: 3, mt: 2.2, minWidth: "100%" }}
                />
              }
            >
              SCOPRI <br /> {chosenLevel.successDialogContent.cta}
            </AppButton>
          </Grid>
          <Grid item sm={6} xs={12}>
            <AppButton
              path="/choose-level"
              size={isMobile ? "medium" : "large"}
              variant={isMobile ? (isWin ? "text" : "outlined") : "outlined"}
              sx={{ justifyContent: "space-around" }}
              endIcon={<Replay />}
            >
              GIOCA {isMobile && isWin ? <></> : <br />} DI NUOVO
            </AppButton>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
});
